import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage2026 from "../pages/article/NajlepszyKakobuySpreadsheet2026/page";
import ArticlePage from "../pages/article/ArticlePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/najlepszy-kakobuy-spreadsheet-2026",
    element: <ArticlePage2026 />,
  },
  {
    path: "/artykul/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
